import { BACKEND_URL } from '@/config/api';

// Solo se envía el final de la conversación y sin mensajes vacíos ni gigantes:
// antes, tras una respuesta larga, todos los mensajes siguientes fallaban.
function _trimHistory(messages) {
  return (messages || [])
    .filter((m) => m && (m.role === 'user' || m.role === 'assistant') && (m.content || '').trim())
    .slice(-14)
    .map((m) => ({ role: m.role, content: String(m.content).slice(0, 7000) }));
}

async function _streamChat(url, messages, headers, { onChunk, onDone, onError }) {
  let res;
  try {
    res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...headers },
      body: JSON.stringify({ messages: _trimHistory(messages) }),
    });
  } catch (err) {
    onError('Error de conexión. Comprueba tu conexión a internet.');
    return;
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    if (res.status === 429) onError(body.detail || 'Has enviado muchos mensajes seguidos. Espera un momento y vuelve a intentarlo.');
    else if (res.status === 401) onError('Tu sesión ha caducado. Vuelve a entrar en el panel.');
    else onError(typeof body.detail === 'string' ? body.detail : 'Ha ocurrido un error. Inténtalo de nuevo.');
    return;
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // keep potentially incomplete last line

      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        const payload = line.slice(6).trim();
        if (payload === '[DONE]') {
          onDone();
          return;
        }
        try {
          const parsed = JSON.parse(payload);
          if (parsed.text) onChunk(parsed.text);
          if (parsed.error) onError(parsed.error);
        } catch {
          // skip malformed SSE line
        }
      }
    }
    onDone();
  } catch (err) {
    onError('Error leyendo la respuesta del servidor.');
  }
}

export function streamPublicChat(messages, callbacks) {
  return _streamChat(
    `${BACKEND_URL}/api/chat/public`,
    messages,
    {},
    callbacks,
  );
}

export function streamPrivateChat(messages, callbacks) {
  const token = sessionStorage.getItem('dashboard_token');
  return _streamChat(
    `${BACKEND_URL}/api/chat/private`,
    messages,
    token ? { Authorization: `Bearer ${token}` } : {},
    callbacks,
  );
}

// Freedy SDR chat for a specific funnel lead. Same SSE contract as the others.
export function streamFunnelChat(leadId, messages, callbacks) {
  return _streamChat(
    `${BACKEND_URL}/api/funnel/lead/${leadId}/chat`,
    messages,
    {},
    callbacks,
  );
}
